<template>
  <div>
    The standby power is typically consumed when a propulsion system
    needs to stay warm between two burns, which means that electrical
    power is consumed even though no thrust is produced. Note that if a
    standby power is specified, this power will also be consumed during
    periods when no thrust is performed (e.g. coasting orbit).
  </div>
</template>

<script>
export default {
  name: 'tooltipStandByPower'
}
</script>
